import React from 'react'
import Footer from '../Footer'
import Uml2 from '../Uml2'

function Umass2() {
    window.scrollTo(0,0);
    return (
        <div>
            <Uml2/>
            <Footer/>
        </div>
    )
}

export default Umass2
